import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="174" height="174" viewBox="0 0 174 174" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="87" cy="87" r="87" fill="url(#paint02_radial)"/>
        <defs>
            <radialGradient id="paint02_radial" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(87 87) rotate(90) scale(87)">
                <stop stopColor="#1A98FF"/>
                <stop offset="1" stopColor="#1A98FF" stopOpacity="0"/>
            </radialGradient>
        </defs>
    </svg>
)
